<div
  id="map"
  leaflet
  leafletDraw
  [ngClass]="(!stage?.includes('pen_tool')) ? 'hide-pentool' : ''"
  [leafletOptions]="mapOptions"
  [leafletDrawOptions]="drawOptions"
  (leafletMapReady)="onMapReady($event)"
  (leafletDrawStart)="drawButtonDetect($event)"
  (leafletClick)="mapClickPoint($event)"
  (leafletDrawCreated)="onDrawCreated($event)">
  <div [leafletLayer]="drawnItems"></div>
</div>
